import React, { Component } from 'react'
import Container from '../../components/layout/container.component'
import Title from '../../components/typography/title.component'
import { StyledRegulation } from './accessibility.styles'

class BenefitsPage extends Component {
	render() {
		const { history } = this.props

		return (
			<Container style={{ paddingBottom: '5rem' }}>
				<Title>
					<span className="bold">ACESSIBILIDADE</span>
				</Title>
				<StyledRegulation>
					<br></br>
					<div>
						<h3>
							<strong>
								Compromisso do Muviflex com a Inclusão Digital e
								Acessibilidade
							</strong>
						</h3>
						<p>
							O Muviflex está profundamente comprometido com a inclusão
							digital e a acessibilidade, reconhecendo a importância de
							garantir que todos os passageiros tenham acesso equitativo
							às tecnologias e aos serviços que oferecemos. Esse
							compromisso se reflete em diversas iniciativas e práticas
							que buscam proporcionar uma experiência de compra mais
							inclusiva e acessível para todos.
						</p>
						<p>
							<strong>Inclusão Digital</strong>
						</p>
						<p>
							A inclusão digital é um dos pilares fundamentais do
							Muviflex. Acreditamos que a tecnologia deve ser um
							facilitador, permitindo que todos os nossos passageiros,
							independentemente de suas habilidades digitais, possam
							usufruir dos benefícios de nossos serviços. Para isso,
							investimos continuamente em soluções tecnológicas que sejam
							intuitivas e de fácil uso.
						</p>
						<ul>
							<li>
								<strong>Plataformas Acessíveis:</strong> Nossos sistemas
								e plataformas digitais são desenvolvidos com o objetivo
								de serem acessíveis a todos. Isso inclui a criação de
								interfaces amigáveis, com navegação simplificada e
								suporte a diferentes dispositivos, garantindo que
								qualquer pessoa possa acessar e utilizar nossos serviços
								sem dificuldades.
							</li>
							<li>
								<strong>Educação Digital:</strong> Promovemos a educação
								digital de nossos passageiros oferecendo suporte técnico
								humanizado para ajudar aqueles que têm menos
								familiaridade com a tecnologia. Nossa missão é empoderar
								os usuários para que possam aproveitar ao máximo os
								recursos disponíveis.
							</li>
						</ul>
						<p>
							<strong>Acessibilidade</strong>
						</p>
						<p>
							O Muviflex entende que a acessibilidade é crucial para
							garantir que todos, incluindo pessoas com deficiência,
							possam utilizar nossos serviços de maneira plena e
							independente. Nosso compromisso com a acessibilidade inclui
							diversas iniciativas:
						</p>
						<ul>
							<li>
								<strong>Desenvolvimento Inclusivo:</strong> Todos os
								nossos serviços digitais são projetados e desenvolvidos
								seguindo as melhores práticas de acessibilidade, como as
								Diretrizes de Acessibilidade para Conteúdo Web (WCAG).
								Isso garante que pessoas com deficiências visuais,
								auditivas, motoras e cognitivas possam navegar e
								interagir com nossas plataformas.
							</li>
							<li>
								<strong>Feedback do Usuário:</strong> Valorizamos o
								feedback dos nossos passageiros e estamos constantemente
								buscando maneiras de melhorar a acessibilidade de nossos
								serviços. Encorajamos os usuários a nos fornecerem suas
								opiniões e sugestões para que possamos continuar a
								evoluir e atender às suas necessidades de maneira
								eficaz.
							</li>
							<li>
								<strong>Treinamento de Equipe:</strong> Nossa equipe é
								treinada para oferecer suporte inclusivo, estando
								preparada para atender passageiros com diversas
								necessidades e garantindo um atendimento personalizado e
								humanizado.
							</li>
						</ul>
						<p>
							<strong>Compromisso Continuado</strong>
						</p>
						<p>
							No Muviflex, acreditamos que a inclusão digital e a
							acessibilidade são processos contínuos e em constante
							evolução. Estamos dedicados a melhorar continuamente nossas
							práticas, adotando novas tecnologias e estratégias que
							possam tornar nossos serviços ainda mais acessíveis e
							inclusivos para todos os passageiros.
						</p>
						<p>
							Nosso compromisso com a inclusão digital e a acessibilidade
							é uma extensão do nosso objetivo maior: proporcionar uma
							experiência de compra única, segura e confiável para todos.
							Acreditamos que, ao promover a igualdade de acesso à
							tecnologia, estamos contribuindo para uma sociedade mais
							justa e inclusiva.
						</p>
					</div>
				</StyledRegulation>
			</Container>
		)
	}
}

export { BenefitsPage as ModuleRootComponent }
